<template>
<section class="u-presentation u-presentation__container" v-if="cards.length > 0">
    <div class="u-presentation-title-wrapper">
        <div class="u-presentation-title">Презентации и проекты</div>
        <button class="u-presentation-download-btn" @click="downloadAllFiles">{{ downloadButtonText }}
            <svg v-if="!isDownloading" width="17" height="16" viewBox="0 0 17 16" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M8.51921 1C8.8874 1 9.18587 1.29848 9.18587 1.66667V8.11809L11.0706 6.23387C11.331 5.97355 11.7531 5.97361 12.0134 6.23399C12.2737 6.49438 12.2737 6.91649 12.0133 7.1768L8.99055 10.1987C8.73021 10.459 8.3082 10.459 8.04786 10.1987L5.02514 7.1768C4.76475 6.91649 4.7647 6.49438 5.02501 6.23399C5.28533 5.97361 5.70744 5.97355 5.96782 6.23387L7.85254 8.11809L7.85254 1.66667C7.85254 1.29848 8.15102 1 8.51921 1ZM2.51921 10C2.8874 10 3.18587 10.2985 3.18587 10.6667L3.18587 14L13.8525 14V10.6667C13.8525 10.2985 14.151 10 14.5192 10C14.8874 10 15.1859 10.2985 15.1859 10.6667V14.1667C15.1859 14.4957 15.0427 14.7982 14.8099 15.0117C14.5791 15.2233 14.2774 15.3333 13.9738 15.3333L3.06466 15.3333C2.761 15.3333 2.45936 15.2233 2.22848 15.0117C1.99566 14.7982 1.85254 14.4957 1.85254 14.1667L1.85254 10.6667C1.85254 10.2985 2.15102 10 2.51921 10Z"
                    fill="#252628" />
            </svg>
        </button>
    </div>
    <div class="u-presentation-wrapper">
        <div class="u-presentation-card" v-for="card in filterCards">
            <div class="u-presentation-card__title">{{ card.description || card.original_name }}</div>
            <a :href="card.src" :title="card.original_name" target="_blank" class="u-presentation-card__link">
                <svg width="21" height="22" viewBox="0 0 21 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M10.4805 0.5C11.0328 0.5 11.4805 0.947715 11.4805 1.5V11.1771L14.3075 8.3508C14.6981 7.96033 15.3313 7.96041 15.7218 8.35099C16.1122 8.74157 16.1121 9.37473 15.7216 9.7652L11.1875 14.2981C10.797 14.6885 10.164 14.6885 9.77345 14.2981L5.23936 9.7652C4.84879 9.37473 4.84871 8.74157 5.23918 8.35099C5.62965 7.96041 6.26282 7.96033 6.65339 8.3508L9.48047 11.1771V1.5C9.48047 0.947715 9.92818 0.5 10.4805 0.5ZM1.48047 14C2.03275 14 2.48047 14.4477 2.48047 15V20H18.4805V15C18.4805 14.4477 18.9282 14 19.4805 14C20.0328 14 20.4805 14.4477 20.4805 15V20.25C20.4805 20.7436 20.2658 21.1974 19.9166 21.5175C19.5702 21.8349 19.1178 22 18.6623 22H2.29865C1.84316 22 1.3907 21.8349 1.04438 21.5175C0.695157 21.1974 0.480469 20.7436 0.480469 20.25V15C0.480469 14.4477 0.928184 14 1.48047 14Z"
                        fill="#82BF00" />
                </svg>
                {{ card.extension.toUpperCase() }}, {{ card.size }}
            </a>
        </div>
    </div>
    <show-more-btn @show-more="showMore" :isLoading="isLoading" v-if="cardCount < cards.length"></show-more-btn>
    <button class="u-presentation-download-btn u-presentation-download-btn-m" @click="downloadAllFiles">{{
        downloadButtonText }}
        <svg v-if="!isDownloading" width="17" height="16" viewBox="0 0 17 16" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                d="M8.51921 1C8.8874 1 9.18587 1.29848 9.18587 1.66667V8.11809L11.0706 6.23387C11.331 5.97355 11.7531 5.97361 12.0134 6.23399C12.2737 6.49438 12.2737 6.91649 12.0133 7.1768L8.99055 10.1987C8.73021 10.459 8.3082 10.459 8.04786 10.1987L5.02514 7.1768C4.76475 6.91649 4.7647 6.49438 5.02501 6.23399C5.28533 5.97361 5.70744 5.97355 5.96782 6.23387L7.85254 8.11809L7.85254 1.66667C7.85254 1.29848 8.15102 1 8.51921 1ZM2.51921 10C2.8874 10 3.18587 10.2985 3.18587 10.6667L3.18587 14L13.8525 14V10.6667C13.8525 10.2985 14.151 10 14.5192 10C14.8874 10 15.1859 10.2985 15.1859 10.6667V14.1667C15.1859 14.4957 15.0427 14.7982 14.8099 15.0117C14.5791 15.2233 14.2774 15.3333 13.9738 15.3333L3.06466 15.3333C2.761 15.3333 2.45936 15.2233 2.22848 15.0117C1.99566 14.7982 1.85254 14.4957 1.85254 14.1667L1.85254 10.6667C1.85254 10.2985 2.15102 10 2.51921 10Z"
                fill="#252628" />
        </svg>
    </button>
</section>
</template>

<script>
import ShowMoreBtn from './ShowMoreBtn.vue'
import { mapState } from 'vuex';

export default {
    name: 'Presentation',
    components: { ShowMoreBtn },
    props: {},

    data() {
        return {
            cardCount: window.innerWidth <= 768 ? 4 : 3,
            isLoading: false,
            isDownloading: false,
            downloadedCount: 0,
            delay: 3000
        };
    },
    watch: {
        // Здесь можно добавить наблюдатели
    },

    beforeCreate() {
        // Вызывается до создания экземпляра компонента
    },

    created() {
        // Вызывается после создания экземпляра компонента
    },

    beforeMount() {
        // Вызывается перед монтированием компонента
    },

    mounted() {
        // Вызывается после монтирования компонента
    },

    computed: {
        // Здесь можно добавить вычисляемые свойства
        ...mapState({
            cards: state => state.data.props.docs,
        }),
        downloadButtonText() {
            if (this.isDownloading) {
                return `Загружается ${this.downloadedCount} из ${this.cards.length}...`;
            }
            return 'Скачать всё';
        },
        filterCards() {
            return this.cards.slice(0, this.cardCount);
        }
    },
    methods: {
        // Здесь можно добавить методы
        showMore() {
            this.isLoading = true;
            setTimeout(() => {
                this.cardCount += this.cardCount;
                this.isLoading = false;
            }, 300)
        },
        downloadAllFiles() {
            if (this.isDownloading) return;

            this.isDownloading = true;
            this.downloadedCount = 0;

            this.cards.forEach((file, index) => {
                setTimeout(() => {
                    this.downloadedCount++;
                    this.downloadFile(file.src, file.original_name);
                    if (this.downloadedCount === this.cards.length) {
                        setTimeout(() => this.isDownloading = false, 1000);
                    }
                }, index * this.delay);
            });
        },
        downloadFile(url, name) {
            const link = document.createElement('a');
            link.href = url;
            link.download = name;
            link.style.display = 'none';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }
};
</script>